import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createSlots as _createSlots, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "mobile-title" }
const _hoisted_2 = { class: "filters" }
const _hoisted_3 = {
  key: 2,
  class: "list"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "type" }
const _hoisted_6 = { class: "bottom" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_PulseInput = _resolveComponent("PulseInput")
  const _component_PulseSearch = _resolveComponent("PulseSearch")
  const _component_PulseButton = _resolveComponent("PulseButton")
  const _component_Loader = _resolveComponent("Loader")
  const _component_Empty = _resolveComponent("Empty")
  const _component_Image = _resolveComponent("Image")
  const _component_Ellipsis = _resolveComponent("Ellipsis")
  const _component_ScrollBar = _resolveComponent("ScrollBar")
  const _component_Divider = _resolveComponent("Divider")
  const _component_Button = _resolveComponent("Button")
  const _component_Popover = _resolveComponent("Popover")

  return (_openBlock(), _createBlock(_component_Popover, {
    modelValue: $data.show,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($data.show) = $event)),
    width: "42.6rem",
    class: "pulse-companies",
    persistent: false,
    "popper-class": "feed-entities-popover",
    placement: "bottom-start",
    "show-arrow": false,
    offset: -1,
    mask: _ctx.$responsive.mobile
  }, {
    reference: _withCtx(() => [
      _createElementVNode("div", {
        class: "trigger",
        onClick: _cache[1] || (_cache[1] = $event => ($data.show = !$data.show))
      }, [
        _createVNode(_component_PulseInput, {
          modelValue: $data.head_text,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.head_text) = $event)),
          class: "pulse-input pointer",
          underline: "",
          readonly: ""
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_Icon, {
              class: _normalizeClass(["icon", {flip: $data.show}]),
              icon: "chevron-down",
              size: "1.6rem",
              stroke: "var(--brand-700)",
              "stroke-width": "1"
            }, null, 8 /* PROPS */, ["class"])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"]),
        _createVNode(_component_Icon, {
          icon: "building-07",
          class: "ref-icon",
          size: "1.6rem",
          stroke: "var(--brand-700)",
          "stroke-width": "1"
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[6] || (_cache[6] = _createElementVNode("span", null, "Select trackers", -1 /* HOISTED */)),
        _createVNode(_component_Icon, {
          class: "pointer",
          icon: "x-close",
          size: "1.8rem",
          stroke: "var(--gray-500)",
          "stroke-width": "1",
          onClick: _cache[2] || (_cache[2] = $event => ($data.show = false))
        })
      ]),
      _createVNode(_component_PulseSearch, {
        modelValue: $data.search,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.search) = $event)),
        loading: $data.loading,
        placeholder: "Search",
        class: "search-input"
      }, null, 8 /* PROPS */, ["modelValue", "loading"]),
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.tracker_types, (item) => {
          return (_openBlock(), _createBlock(_component_PulseButton, {
            key: item.value,
            active: $data.type === item.value,
            "icon-size": _ctx.$responsive.mobile ? '1.6rem' : undefined,
            small: !_ctx.$responsive.mobile,
            icon: _ctx.$responsive.mobile ? item.icon : undefined,
            text: item.title,
            count: $options.calcCount(item.value),
            onClick: $event => ($data.type = $data.type === item.value ? undefined : item.value)
          }, null, 8 /* PROPS */, ["active", "icon-size", "small", "icon", "text", "count", "onClick"]))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _createVNode(_component_ScrollBar, {
        class: "scrollbar",
        relative: ""
      }, {
        default: _withCtx(() => [
          ($data.loading)
            ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }))
            : ($options.empty)
              ? (_openBlock(), _createBlock(_component_Empty, {
                  key: 1,
                  bordered: false,
                  class: "empty",
                  "bg-size": "36rem",
                  "circle-size": "7.6rem"
                }, _createSlots({ _: 2 /* DYNAMIC */ }, [
                  ($data.search || $data.type)
                    ? {
                        name: "sub-text",
                        fn: _withCtx(() => [
                          _cache[7] || (_cache[7] = _createTextVNode(" There are no trackers matching your criteria")),
                          _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1 /* HOISTED */)),
                          _createElementVNode("a", {
                            class: "pointer",
                            onClick: _cache[4] || (_cache[4] = (...args) => ($options.clearFilters && $options.clearFilters(...args)))
                          }, "Clear filters")
                        ]),
                        key: "0"
                      }
                    : undefined,
                  ($data.search || $data.type)
                    ? {
                        name: "image",
                        fn: _withCtx(() => [
                          _createVNode(_component_Icon, {
                            width: "4rem",
                            height: "4rem",
                            icon: "search",
                            class: "icon-svg",
                            stroke: "var(--brand-500)"
                          })
                        ]),
                        key: "1"
                      }
                    : {
                        name: "image",
                        fn: _withCtx(() => [
                          _createVNode(_component_Icon, {
                            width: "4rem",
                            height: "4rem",
                            icon: "activity",
                            class: "icon-svg",
                            stroke: "var(--brand-500)"
                          })
                        ]),
                        key: "2"
                      }
                ]), 1024 /* DYNAMIC_SLOTS */))
              : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.entities, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.id,
                      class: _normalizeClass(["item pointer", {chosen: $data.chosen.has(item.id)}]),
                      onClick: $event => ($data.chosen.has(item.id) ? $data.chosen.delete(item.id) : $data.chosen.add(item.id))
                    }, [
                      (item.type !== 'topic')
                        ? (_openBlock(), _createBlock(_component_Image, {
                            key: 0,
                            size: "2.4rem",
                            src: item.icon_url,
                            shape: "square",
                            placeholder: "assets/company-placeholder.png"
                          }, null, 8 /* PROPS */, ["src"]))
                        : _createCommentVNode("v-if", true),
                      _createVNode(_component_Ellipsis, {
                        class: "name",
                        text: item.name
                      }, null, 8 /* PROPS */, ["text"]),
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_Icon, {
                          icon: $options.getType(item.type)?.icon,
                          width: "1.4rem",
                          height: "1.4rem",
                          stroke: "var(--brand-400)",
                          "stroke-width": "1"
                        }, null, 8 /* PROPS */, ["icon"]),
                        _createTextVNode(" " + _toDisplayString($options.getType(item.type)?.title), 1 /* TEXT */)
                      ]),
                      _createVNode(_component_Icon, {
                        class: "check",
                        icon: "check",
                        size: "1.6rem",
                        stroke: "var(--brand-500)"
                      })
                    ], 10 /* CLASS, PROPS */, _hoisted_4))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_Divider, { m: "0 -1.6rem" }),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_Button, {
          tiny: !_ctx.$responsive.mobile,
          text: !_ctx.$responsive.mobile,
          disabled: !$options.can_clear,
          onClick: $options.clearAll
        }, {
          default: _withCtx(() => _cache[9] || (_cache[9] = [
            _createTextVNode("Clear selection")
          ])),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["tiny", "text", "disabled", "onClick"]),
        _createVNode(_component_Button, {
          disabled: !$options.changed,
          tiny: !_ctx.$responsive.mobile,
          primary: "",
          class: "apply",
          onClick: $options.apply
        }, {
          default: _withCtx(() => _cache[10] || (_cache[10] = [
            _createTextVNode("Apply")
          ])),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["disabled", "tiny", "onClick"])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue", "mask"]))
}